import numeric from '../common/directives/numberic';
import {
  vCNPJ,
  vCEP,
  vDateFull,
  vDateInternational,
  vHour,
  vMesAno,
  vMoney,
  vPhone,
} from '../common/directives/masks';

export default (Vue) => {
  // Exemplo de como usar uma diretiva em Vue
  Vue.directive('cnpj', vCNPJ);
  Vue.directive('cep', vCEP);
  Vue.directive('datefull', vDateFull);
  Vue.directive('dateinternational', vDateInternational);
  Vue.directive('hour', vHour);
  Vue.directive('mesAno', vMesAno);
  Vue.directive('money', vMoney);
  Vue.directive('numeric', numeric);
  Vue.directive('phone', vPhone);
};



// WEBPACK FOOTER //
// ./src/config/directives.js